import AppraisalsTable from './AppraisalsTable';

export default AppraisalsTable;
